import {
  Box,
  Checkbox,
  Group,
  LoadingOverlay,
  TextInput,
  Textarea,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { useEffect, useState } from "react";
import { repositoryMdm } from "../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../../model/MessageResponse";
import { TblDMExpense } from "../../../../model/TblDMExpense";

const DetailCommune = ({ id }: DetailDataViewProps) => {
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [dataProvince, setDataProvince] = useState<any>([]);
  const form = useForm<any>({
    mode: "controlled",
    validateInputOnChange: true,
    initialValues: {},
  });

  const callApiGetData = async () => {
    open();
    const callapi = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblDmCommuneMoi/detail?id=${id}`
    );
    if (callapi) {
      const dataApi = callapi?.data;
      if (dataApi != null) {
        form.setValues(dataApi);
        form.resetDirty(dataApi);
      }
      close();
    } else {
      NotificationExtension.Fails("Dữ liệu không tồn tại");
      modals.closeAll();
    }
  };
  const callProvince = async () => {
    try {
      const response = await repositoryMdm.get<MessageResponse<[]>>(
        `/api/v1/TblDmProvinceMoi/get-list?Active=true&Take=100`
      );
      if (response && response.success) {
        const result = response.data
          .filter((i: any) => i.id !== null && i.codeprovince !== null)
          .map((item: any) => ({
            value: String(item.id),
            label: item.name,
          }));
        const valueProvince = result.find(
          (item: any) => item.value === String(form.values.provinceId)
        );
        console.log("dataProvince", result);
        console.log("object", valueProvince);
        setDataProvince(valueProvince?.label || "");
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };
  useEffect(() => {
    if (id) {
      callApiGetData();
    }
  }, [id]);

  useEffect(() => {
    if (form.values.provinceId) {
      callProvince();
    }
  }, [form.values.provinceId]);

  return (
    <>
      <Box
        component="form"
        mx="auto"
        w={{ base: "280px", md: "336px", lg: "448px" }}
        style={{ position: "relative" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Group wrap="nowrap" mt={10} gap={"lg"}>
          <TextInput
            variant="filled"
            readOnly
            label={"Mã"}
            {...form.getInputProps("code")}
          />
          <TextInput
            variant="filled"
            readOnly
            label={"Tên"}
            w={"100%"}
            {...form.getInputProps("name")}
          />
        </Group>
        {/* <Group grow wrap="nowrap" mt={10} mb={"md"} gap={"lg"} align="center">
          <TextInput
            variant="filled"
            readOnly
            label={"Mã web"}
            {...form.getInputProps("codeCommuneWeb")}
          />
        </Group> */}
        <Group grow wrap="nowrap" mt={10} mb={"md"} gap={"lg"} align="center">
          <TextInput
            variant="filled"
            readOnly
            label={"Tên tỉnh/thành phố"}
            w={"100%"}
            defaultValue={dataProvince}
            // {...form.getInputProps("provinceName")}
          />
        </Group>
        {/* <Group grow wrap="nowrap" mt={10} mb={"md"} gap={"lg"} align="center">
          <TextInput
            variant="filled"
            readOnly
            label={"Tên huyện"}
            {...form.getInputProps("districtName")}
          />
        </Group> */}
        <Group grow wrap="nowrap" mt={10} mb={"md"} gap={"lg"} align="center">
          <Textarea
            label={"Ghi chú"}
            variant="filled"
            readOnly
            w={"100%"}
            {...form.getInputProps("note")}
          />
        </Group>
        <Checkbox
          label={"Sử dụng"}
          readOnly
          checked={form.values.active}
          {...form.getInputProps("active")}
          onChange={() => {}}
        />
      </Box>
    </>
  );
};

export default DetailCommune;

type DetailDataViewProps = {
  id: number;
};
